import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod } from '../../open-api.method';

@OpenApiMethod({
  method: HttpMethods.GET,
  apiName: 'customer',
  path: '/profile/user-role',
  operationId: 'ProfileController_getUserRole',
  parameters: [],
})
export class ProfileControllerGetUserRoleMethod extends BaseOpenApiMethod<void> implements Method<void, void> {
  public call(): Promise<void> {
    return super.call();
  }
}
